import {webRequest, webNoTokenRequest} from '../api'

// 上傳影片
export function uploadVideo(data) {
    return webRequest({
        url:'/v1/oauth/management/house/upload/houseFilm',
        method:'post',
        data: data,
    })
}

// 上傳影片
export function uploadHouseAttorney(data) {
    return webRequest({
        url:'/v1/oauth/management/house/upload/houseAttorney',
        method:'post',
        data: data,
    })
}

// 合約版本列表
export function getHouseAttorney(params) {
    return webRequest({
        url:'/v1/oauth/management/house/get/houseAttorney',
        method:'get',
        responseType: "arraybuffer",
        params: params
    })
}

// 取得房源明細（與企業共用）
export function getHouseDetail(params) {
    return webNoTokenRequest({
        url:'/v2/house/findtarget/details',
        method:'get',
        params: params
    })
}

// 房源管理
export function getHouseMgtList (params) {
  return webRequest({
    url:'/v1/oauth/management/house/list',
    method:'get',
    params: params
  });
}

// 房源管理V2
export function getHouseMgtListV2 (params) {
  return webRequest({
    url:'/v2/oauth/management/house/list',
    method:'get',
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/apis/company/houseMgt.js